import React, { useEffect } from "react";
import {
	Location,
	Navigate,
	useLocation,
	useNavigate,
	useParams,
} from "react-router";
import { VelavuRule } from "velavu-js-api";
import RulesEditor from "./rules-editor";
import { useHasPermission } from "../../sign-in-context/sign-in-context";

// Using '/rules/create' is a special rule ID for creating a new rule
const RULE_ID_CREATE = "create";

export default function RulesEditorPath() {
	//Retrieve the rule ID
	const params = useParams();
	const ruleID = params.ruleID!;
	const canWriteRules = useHasPermission("rules:write");

	const location = useLocation() as Location<{
		rule: VelavuRule;
	} | null>;
	const rule = location?.state?.rule;

	const navigate = useNavigate();
	// If no rule is provided and we're not creating a new rule, redirect to the rules list
	useEffect(() => {
		if (ruleID !== RULE_ID_CREATE && !rule) {
			navigate("/rules");
		}
	}, [ruleID, rule, navigate]);

	if (ruleID === RULE_ID_CREATE) {
		//Make sure we have permission to create a new rule
		if (!canWriteRules) {
			return <Navigate to="/rules" replace />;
		}
		return <RulesEditor rule={null} />;
	} else if (rule) {
		return <RulesEditor rule={rule} />;
	} else {
		return null;
	}
}
